import { createUseStyles } from "react-jss";

export const useStylesSuggestionsData: any = createUseStyles(() => ({
  suggestedAdItemsWrapper: {
    width: "100%",
    padding: '0 5px',
    marginTop: '5px',
  },
}));
